import React, { useContext, useEffect } from "react";
import { Tooltip, useDisclosure } from "@chakra-ui/react";
import { ButtonHeaderModule } from "styled/Buttons.styled";
import { IconGeneric } from "styled/Icons.styled";
import { RiDeviceRecoverFill } from "react-icons/ri";
import { MdContentCopy } from "react-icons/md";
import { BiShow } from "react-icons/bi";
import { FaHistory } from "react-icons/fa";
import { AuthContext } from "context/AuthContext";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import IntegracionBoxCrudContex from "context/IntegracionBoxCrudContex";
import { useFormBlocker } from "hooks/useFormBlocker";
import environment from "constants/apiConst";
import Swal from "sweetalert2";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import { FaUnlock } from "react-icons/fa";
import { __Post } from "request/Petitions/__Post";
import { useSelector } from "react-redux";
import { useGlobalLoading } from 'utils/globalLoading'
import ModalReturnHistory from "components/modal/ModalReturnHistory";

export const Buttonssubmitted = ({
  handleShow,
  handleCopy,
  handleStatusBox,
  handleNavigateReview,
  handleNavigateCorrected,
  handleChangeStatusCorrected,
  valuesCorrected
}) => {
  const { ChangeStatusCertified, form } = useContext(IntegracionBoxCrudContex);
  const { authUser } = useContext(AuthContext);

  const location = useLocation();
  const { idCorrected = null, id = null } = queryString.parse(location.search);
  const [openAlert] = AlertErrorAlert()
  const token = useSelector((state) => state.auth.dataUser.token);

  const { isLoading: isLoadingButton } = useGlobalLoading()
  const { isOpen: isOpenReturnHistory, onOpen: onOpenReturnHistory, onClose: onCloseReturnHistory } = useDisclosure()
  
  // Obtener el form correcto según si es corrección o no
  const currentForm = idCorrected ? (valuesCorrected?.data || form?.newData?.data || form) : form;

  const { blockForm, formLockQueryResult, isBlocked } = useFormBlocker({
    form_id: id || idCorrected,
    type_of: id ? "CI" : "CIC",
    userProvidedEndpoint: environment.FORMS_ON_REVIEW
  });

  const showAlert = (title, message, callback = () => { }, status) => {
    Swal.fire({
      title,
      text: message,
      showCancelButton: true,
      confirmButtonText: "Desbloquear",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1e75bb",
      position: "top"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const body = new FormData();
        body.append("form_id", id || idCorrected);
        body.append("type_of", id ? "CI" : "CIC");
        body.append("type", 2);
        const res = await __Post(environment.FORMS_ON_REVIEW, token, body);
        if (res?.data?.status?.code === 200) {
          openAlert('Formulario desbloqueado', 'success')
          blockForm(2);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("cancel");
      }
    });
  };

  const showAlert2 = (title, message, status) => {
    Swal.fire({
      title,
      text: message,
      showCancelButton: true,
      confirmButtonText: "Desbloquear",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1e75bb",
      position: "top"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const body = new FormData();
        body.append("form_id", id || idCorrected);
        body.append("type_of", id ? "CI" : "CIC");
        body.append("type", 2);
        const res = await __Post(environment.FORMS_ON_REVIEW, token, body);
        if (res?.data?.status?.code === 200) {
          openAlert('Formulario desbloqueado', 'success')
          blockForm(2);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("cancel");
      }
    });
  };

  const ChangeStatus = async (status) => {
    const reviewIntegrationCertificate = {
      id,
      status
    };

    if (isBlocked) {
      showAlert("¿Deseas desbloquear el cuadro de integración?", formLockQueryResult?.message, status);
      return;
    }

    if (!isBlocked) {
      ChangeStatusCertified(reviewIntegrationCertificate, handleShow);

    }
  };

  const ChangeStatusCorrected = () => {
    if (isBlocked) {
      showAlert2("¿Deseas desbloquear el cuadro de integración corregido?", formLockQueryResult?.message);
      return;
    }

    if (!isBlocked) {
      handleNavigateReview()
    }
  }

  return (
    <>
      <ModalReturnHistory
        isOpen={isOpenReturnHistory}
        onClose={onCloseReturnHistory}
        onOpen={onOpenReturnHistory}
        title={'Historial de Devoluciones'}
        size={'3xl'}
        entryFormId={idCorrected || id}
        isOutputForm={false}
        isIntegrationCertificate={!idCorrected}
        isIntegrationCertificateCorrected={!!idCorrected}
      />
      {currentForm?.reason_for_return && (
        <Tooltip placement='top' hasArrow label='Historial de Devoluciones'>
          <span>
            <ButtonHeaderModule
              onClick={onOpenReturnHistory}
              bgColor='#FF9800'
              className='mx-1'
              isLoading={isLoadingButton}
            >
              <IconGeneric
                width='16px'
                className='text-white'
                as={FaHistory}
              />
            </ButtonHeaderModule>
          </span>
        </Tooltip>
      )}
      {authUser.is_qualified_user !== 1 && isBlocked && <Tooltip placement="top" hasArrow label="Desbloquear">
        <span>
          <ButtonHeaderModule
            onClick={() => {
              id && ChangeStatus("REVISADO")
              idCorrected && ChangeStatusCorrected()
            }}
            className="mx-1"
            bgColor="#fe8d59"
            isLoading={isLoadingButton}
          >
            <IconGeneric
              width="16px"
              className="text-white"
              as={FaUnlock}
            />
          </ButtonHeaderModule>
        </span>
      </Tooltip>}

      {idCorrected
        ? (
          <>
            <Tooltip placement="top" hasArrow label="Recuperar">
              <span>
                <ButtonHeaderModule
                  onClick={() => isBlocked ? openAlert(formLockQueryResult?.message, 'error') : handleChangeStatusCorrected("BORRADOR")}
                  className="mx-1"
                  bgColor="#1F7AC3"
                  // disabled={isBlocked}
                  isLoading={isLoadingButton}
                >
                  <IconGeneric
                    width="16px"
                    className="text-white"
                    as={RiDeviceRecoverFill}
                  />
                </ButtonHeaderModule>
              </span>
            </Tooltip>

            {authUser.is_qualified_user !== 1 && idCorrected && (
              <Tooltip placement="top" hasArrow label="Revisar">
                <span>
                  <ButtonHeaderModule
                    onClick={handleNavigateReview}
                    className="mx-1"
                    bgColor="#58B158"
                    // disabled={isBlocked}
                    isLoading={isLoadingButton}
                  >
                    <IconGeneric width="16px" className="text-white" as={BiShow} />
                  </ButtonHeaderModule>
                </span>
              </Tooltip>
            )}
          </>
        )
        : (
          <>
            <Tooltip placement="top" hasArrow label="Recuperar">
              <span>
                <ButtonHeaderModule
                  onClick={() => isBlocked ? openAlert(formLockQueryResult?.message, 'error') : handleStatusBox("BORRADOR")}
                  className="mx-1"
                  bgColor="#1F7AC3"
                  // disabled={isBlocked}
                  isLoading={isLoadingButton}
                >
                  <IconGeneric
                    width="16px"
                    className="text-white"
                    as={RiDeviceRecoverFill}
                  />
                </ButtonHeaderModule>
              </span>
            </Tooltip>

            {authUser.is_qualified_user !== 1 && !idCorrected && (
              <Tooltip placement="top" hasArrow label="Revisar">
                <span>
                  <ButtonHeaderModule
                    onClick={() => ChangeStatus("REVISADO")}
                    className="mx-1"
                    bgColor="#58B158"
                    // disabled={isBlocked}
                    isLoading={isLoadingButton}

                  >
                    <IconGeneric width="16px" className="text-white" as={BiShow} />
                  </ButtonHeaderModule>
                </span>
              </Tooltip>
            )}

            <Tooltip placement="top" hasArrow label="Copiar">
              <span>
                <ButtonHeaderModule
                  onClick={handleCopy}
                  className="mx-1"
                  bgColor="#eeca06"
                  isLoading={isLoadingButton}
                >
                  <IconGeneric width="16px" className="text-white" as={MdContentCopy} />
                </ButtonHeaderModule>
              </span>
            </Tooltip>
          </>
        )}
    </>
  );
};
